import { request } from './client';

export const apiGetReviews = (bookId) => request(`/reviews/${bookId}`);

export const apiAddReview = (bookId, rating, text) =>
  request(`/reviews/${bookId}`, { method: 'POST', body: { rating, text } });

export const apiGetMyReviews = () => request('/reviews/me');

export const apiGetEligibleReviewItems = () => request('/reviews/me/eligible');

export const apiGetMyHelpfulReviews = () => request('/reviews/me/helpful');

export const apiUpdateReview = (reviewId, rating, text) =>
  request(`/reviews/${reviewId}`, { method: 'PUT', body: { rating, text } });

export const apiDeleteReview = (reviewId) =>
  request(`/reviews/${reviewId}`, { method: 'DELETE' });

export const apiMarkHelpful = (reviewId) =>
  request(`/reviews/${reviewId}/helpful`, { method: 'PUT' });
